window.cartUpsellSlider = function(){
    const swiper = new Swiper(".mySwiper", {
      loop: false,
      slidesPerView: "auto",
      spaceBetween: 16,
      autoplay:false,
       pagination: {
        el: ".swiper-pagination-progressbar",
        type: "progressbar"
      }
    });
}
window.cartUpsellSlider();


document.addEventListener('DOMContentLoaded', function () {
    const wrapper = document.querySelector('.custom-sort-wrapper');
    const label = wrapper?.querySelector('.custom-sort-label');
    const activeText = wrapper?.querySelector('.active-sort-text');
    const dropdown = wrapper?.querySelector('.custom-sort-dropdown');
    const realSelect = wrapper?.querySelector('.hidden-sort-select');
    const items = wrapper?.querySelectorAll('.sort-item');

    // Set active text on load
    const selectedOption = realSelect.options[realSelect.selectedIndex].text;
    activeText.textContent = selectedOption;

    // Toggle dropdown
    label.addEventListener('click', () => {
      wrapper.classList.toggle('open');
    });

    // Click option
    items.forEach((item) => {
      item.addEventListener('click', function () {
        const value = this.dataset.value;

        // update real select
        realSelect.value = value;
        // realSelect.dispatchEvent(new Event('change'));
        realSelect.dispatchEvent(new Event('input', { bubbles: true }));
        realSelect.dispatchEvent(new Event('change', { bubbles: true }));
        

        // update visible text
        activeText.textContent = this.textContent;

        // update active class
        items.forEach((i) => i.classList.remove('active'));
        this.classList.add('active');

        // close dropdown
        wrapper.classList.remove('open');
      });
    });

    // Close on outside click
    document.addEventListener('click', function (e) {
      if (!wrapper.contains(e.target)) {
        wrapper.classList.remove('open');
      }
    });
  });

//   document.addEventListener('submit', function(e) {
//   const form = e.target.tagName === 'FORM' ? e.target : e.target.closest('form[data-type="add-to-cart-form"]');
//   if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;

//   const selectedSwatch = document.querySelector('.VariantSwatch.selected');
//   if (!selectedSwatch) return;

//   const selectedVariant = selectedSwatch.dataset.variant;
//   if (!selectedVariant) return;

//   const variantPropertyInput = form.querySelector('.variant-property');
//   if (variantPropertyInput) {
//     variantPropertyInput.value = selectedVariant;
//   }
// }, true);

// Persoanlizer Popup JS Start
window.initPersonalizerPopup = function (){
  const openBtns = document.querySelectorAll(".custom-personalizebtn");
  const popups = document.querySelectorAll(".personalize__custom-popup");
  if(popups.length > 0){
    popups.forEach(popup=>{
      const popupInner = popup.querySelector(".personalize__custom-popup__media");
      const closeBtn = popup.querySelector(".personalize__custom-popup__closeicon");

      
      // Show/hide personalize button based on whether it's inside .product__info-wrapper
      const visibleBtns = [];
      
      // Find the section with custom-main-product class
      const customMainProductSection = popup.closest("product-info");
      
      openBtns.forEach((btn) => {
        
        if (customMainProductSection) {
          // Check if the button is inside the custom-main-product section
          const isInCustomMainProduct = customMainProductSection && customMainProductSection.contains(btn);
          
          // Show button only if it's inside .custom-main-product .product .product__info-wrapper
          if (isInCustomMainProduct) {
            btn.style.display = "";
            visibleBtns.push(btn);
          } else {
            btn.style.display = "none";
          }
        } else {
          btn.style.display = "none";
        }
      });
      
      // Only run on pages where the popup exists and there are visible buttons
      if (!popup || !popupInner || visibleBtns.length === 0) return;
      
      visibleBtns.forEach((btn) => {
        btn.addEventListener("click", async function () {
          console.log("custom-personalizebtn clicked");
          popup.classList.add("active");
          document.body.classList.add("personalize-popup__active");
          await cloneWrapper(popup);
          clickOnMainATCButton(popup);
          updatePopupPrice(popup);
          window.initPersonalizerPopup();          
        });
      });
      
      if (closeBtn) {
        closeBtn.addEventListener("click", function () {
          popup.classList.remove("active");
          document.body.classList.remove("personalize-popup__active");
        });
      }
      
      // Close when clicking anywhere outside the inner popup box or buttons
      // document.addEventListener("click", function (e) {
        //   if (!popup.classList.contains("active")) return;
        
        //   const clickedInsidePopup = popupInner.contains(e.target);
        //   const clickedOpenButton = visibleBtns.some((btn) =>
          //     btn.contains(e.target)
        //   );
        
        //   if (!clickedInsidePopup && !clickedOpenButton) {
          //     popup.classList.remove("active");
          //     document.body.classList.remove("personalize-popup__active");  
          //   }
          // });
          
          // Personalize input validation and character counter

      const popup_wrappers = popup.querySelectorAll(".personalize__custom-popup__wrapper");
      if(popup_wrappers.length > 0){
        popup_wrappers.forEach(popup_wrapper=>{
          const personalizeInput = popup_wrapper.querySelector('.personalize-input');
          const charCounterLarge = popup_wrapper.querySelector('.persoanlize__custom-popup__rightdescright .largecontent');
          const charCounterSmall = popup_wrapper.querySelector('.persoanlize__custom-popup__rightdescright .smallcontent');
          const placeholderText = popup_wrapper.querySelector('.personalize-placeholder__text span');
          
          if (personalizeInput && (charCounterLarge || charCounterSmall)) {
            const maxLength = parseInt(personalizeInput.getAttribute('maxlength')) || 2;
            const minLength = parseInt(personalizeInput.getAttribute('minlength')) || 2;
            const defaultPlaceholder = placeholderText ? placeholderText.textContent.trim() : 'HP';
        
            function updateCounter() {
              const currentLength = personalizeInput.value.length;
              const remaining = maxLength - currentLength;
              
              // Update large content span
              if (charCounterLarge) {
                if (remaining >= 0) {
                  charCounterLarge.textContent = `${remaining} ${remaining !== 1 ? '' : ''} `;
                } else {
                  charCounterLarge.textContent = '';
                }
              }
              
              // Update small content span (X/2 format)
              if (charCounterSmall) {
                charCounterSmall.textContent = `${currentLength}/${maxLength}`;
              }
        
              // Add validation classes
              if (currentLength < minLength) {
                personalizeInput.classList.add('invalid');
                personalizeInput.classList.remove('valid');
              } else if (currentLength === maxLength) {
                personalizeInput.classList.add('valid');
                personalizeInput.classList.remove('invalid');
              } else {
                personalizeInput.classList.remove('invalid', 'valid');
              }
            }
        
            function updatePlaceholderText() {
              if (placeholderText) {
                const inputValue = personalizeInput.value;
                if (inputValue.length > 0) {
                  // Show the typed text in the placeholder
                  placeholderText.textContent = inputValue;
                } else {
                  // Show default placeholder when empty
                  placeholderText.textContent = defaultPlaceholder;
                }
              }
            }        
        
            // Update on input
            personalizeInput.addEventListener('input', function(e) {
              // Convert to uppercase
              this.value = this.value;
              // Enforce max length
              if (this.value.length > maxLength) {
                this.value = this.value.slice(0, maxLength);
              }
              updateCounter();
              updatePlaceholderText();
        
              if(this.classList.contains('invalid_chars')) this.classList.remove('invalid_chars');
        
              // if (popupInner) {
              //   const additionalPriceInput = popupInner.querySelector('.additional_personalize_price');
              //   const priceEle = popupInner.querySelector('.personalize_price');
              //   if(additionalPriceInput && priceEle){
              //     const additionalPrice = additionalPriceInput.getAttribute('data-additional-price-value');
              //     const mainPrice = additionalPriceInput.getAttribute('data-main-price-value');
              //     if(this.value.length > 0){
              //       priceEle.innerText = additionalPrice;
              //     } else {
              //       priceEle.innerText = mainPrice;
              //     }
              //   }
              // }
              updatePopupPrice(popup);
            });
        
            // Validate on blur
            // personalizeInput.addEventListener('blur', function() {
            //   if (this.value.length < minLength) {
            //     this.setCustomValidity(`Please enter at least ${minLength} characters`);
            //   } else {
            //     this.setCustomValidity('');
            //   }
            //   updateCounter();
            //   updatePlaceholderText();
            // });
        
            // Initialize counter and placeholder
            updateCounter();
            updatePlaceholderText();
          }
        })
      }
    })
  }
}; 

function updatePopupPrice(popup) {
  var emptyInput = 1;
  const additionalPriceInput = popup.querySelector('.additional_personalize_price');
  const priceEle = popup.querySelector('.personalize_price');
  if (additionalPriceInput && priceEle) {
    const additionalPrice = parseFloat(additionalPriceInput.getAttribute('data-additional-price-value'));
    const mainPrice = parseFloat(additionalPriceInput.getAttribute('data-main-price-value'));
    const personalizationFee = parseFloat(additionalPriceInput.getAttribute('data-personalization-fee')) || 0;
    const currencySymbol = additionalPriceInput.getAttribute('data-current-currency');
    const allInputFields = popup.querySelectorAll('.personalize-input');
    if (allInputFields.length > 0) {
      const hasEmptyField = Array.from(allInputFields).some(input => input.value.length > 0);
      if (hasEmptyField) {
        emptyInput = 0;
      }
    }
    const _closestProductInfo = popup.closest("product-info");
    if(_closestProductInfo){
      const volumeUpsellWrapper = _closestProductInfo.querySelector('.js-volume-upsell');
      if(volumeUpsellWrapper){
        const selectedInput = [...volumeUpsellWrapper.querySelectorAll('.custom_volume[name="custom-upsell__volume"]')].find(input=> input.checked);
        const selectedQty = selectedInput ? Number(selectedInput.value) : 1;
        if(emptyInput == 0){
          const calculatedValue = `${currencySymbol}${(additionalPrice * selectedQty + (personalizationFee * selectedQty)).toFixed(2)}`
          priceEle.innerText = calculatedValue.replaceAll('.',',');
        } else if(emptyInput == 1){
          const calculatedValue = `${currencySymbol}${(mainPrice * selectedQty).toFixed(2)}`
          priceEle.innerText = calculatedValue.replaceAll('.',',');
        }
      } else{
        if(emptyInput == 0){
          const calculatedValue = `${currencySymbol}${(additionalPrice + personalizationFee).toFixed(2)}`
          priceEle.innerText = calculatedValue.replaceAll('.',',');
        } else if(emptyInput == 1){
          const calculatedValue = `${currencySymbol}${mainPrice.toFixed(2)}`
          priceEle.innerText = calculatedValue.replaceAll('.',',');
        }
      }
    }
  }
}

function clickOnMainATCButton(popup){
  const closestProductInfo = popup.closest("product-info");
  const personalize_add_button = popup.querySelector('.personalize_add_button')?.querySelector('button');
  if(personalize_add_button && !personalize_add_button.dataset.atcBound){
    personalize_add_button.dataset.atcBound = 'true';
    personalize_add_button.addEventListener('click', ()=>{
      if(closestProductInfo){
        const mainATCButton = closestProductInfo.querySelector('product-form button[name="add"]');
        if(mainATCButton){
          mainATCButton.click();
        }
      }
    });
  }
}

async function cloneWrapper(popup) {
  const _customMainProductSection = popup.closest("product-info");
  if(_customMainProductSection){
    const volumeUpsellWrapper = _customMainProductSection.querySelector('.js-volume-upsell');
    if(!volumeUpsellWrapper) return;
    if(volumeUpsellWrapper){
      const selectedInput = [...volumeUpsellWrapper.querySelectorAll('.custom_volume[name="custom-upsell__volume"]')].find(input=> input.checked);
      const popupWrapper = popup.querySelector('.personalize__custom-popup__wrapper');
      const appendAfterEle = popup.querySelector('.personalize__custom-popup__closeicon');
      if(popupWrapper && selectedInput){
        const value = Number(selectedInput.value);
        const allWrappers = popup.querySelectorAll('.personalize__custom-popup__wrapper');
        for (let i = 1; i < allWrappers.length; i++) {
          allWrappers[i].remove();
        }
        for (let i = 1; i < value; i++) {
          const clone = popupWrapper.cloneNode(true);
          appendAfterEle.insertAdjacentElement('afterend', clone)
        }
      }
    }
  }
}

window.initPersonalizerPopup();
// Persoanlizer Popup JS End

// Custom Voulme Upsell Quantities
window.volumeUpsellQuantities = function(){
  const allVolumeUpsellContainers = document.querySelectorAll('.js-volume-upsell');
  if(allVolumeUpsellContainers.length > 0){
    allVolumeUpsellContainers.forEach(volumeUpsellContainer =>{
      const closestProductInfo = volumeUpsellContainer.closest('product-info');
      const allUpsellItems = volumeUpsellContainer.querySelectorAll('.custom_volume[name="custom-upsell__volume"]');
      if(closestProductInfo){
        const inputQuantityField = closestProductInfo.querySelector('.quantity__input[name="quantity"]');
        if(allUpsellItems.length > 0){
          const alreadyCheckedInput = [...allUpsellItems].find(input=> input.checked);
          if(inputQuantityField) inputQuantityField.value = alreadyCheckedInput.value;
          allUpsellItems.forEach(item=>{
            item.addEventListener('change', ()=>{
              if(inputQuantityField){
                inputQuantityField.value = item.value;
              }
            })
          })
        }
      }
    })
  }
}
window.volumeUpsellQuantities();


// Bundle custom js starts
window.customBundleFunctionality = function(){
  const SimpleBundleDropdownOptionsContainer = document.querySelector('.product__info-wrapper #simple-bundles-io-options');
  const SimpleBundleSwatchesContainer = document.querySelector('.product__info-wrapper [data-sb-io]');
  
  if(SimpleBundleDropdownOptionsContainer && SimpleBundleSwatchesContainer){
    const allSelectTagsFromDropdownOption = SimpleBundleDropdownOptionsContainer.querySelectorAll('select');
    if(allSelectTagsFromDropdownOption.length > 0){
      allSelectTagsFromDropdownOption.forEach(select=>{
  
        const allSimpleBundleSwatches = SimpleBundleSwatchesContainer.querySelectorAll('.sb-io__swatch');
        if(allSimpleBundleSwatches.length > 0){
          allSimpleBundleSwatches.forEach(swatch=>{
            const swatch_data_title = swatch.getAttribute('data-option-value');
            const allOptions = select.querySelectorAll('option');
            if(allOptions.length > 0){
              allOptions.forEach(option=>{
                if(option.hasAttribute('disabled') && option.value == swatch_data_title){
                  swatch.setAttribute('disabled', true);
                }
              })
            }
            if(select.value == swatch_data_title){
              swatch.setAttribute('aria-pressed', true);
              const optionLabelParent = swatch.closest('.sb-io__group-content');
              const optionLabelInner = optionLabelParent.querySelector('.selected-swatch-label');
              optionLabelInner.innerText = swatch_data_title;
            }
          })
        }
      })
    }

    const SimpleBundleGroups = SimpleBundleSwatchesContainer.querySelectorAll('.sb-io__group');
    if(SimpleBundleGroups.length > 0){
      SimpleBundleGroups.forEach(group=>{
        const swatchContainer = group.querySelector('.sb-io__swatches');
        if(swatchContainer){
          const allSwatchButtons = swatchContainer.querySelectorAll('[data-sb-io-swatch]');
          if(allSwatchButtons.length > 0){
            allSwatchButtons.forEach(swatch=>{
              swatch.addEventListener('click', ()=>{

                const mainGroup = swatch.closest('.sb-io__group');
                const thumbImageMain = mainGroup.querySelector('.sb-io__product-thumb img');
                const swatchIndex = swatch.getAttribute('data-prop-key');
                if (swatchIndex == 'Product 2' || swatchIndex == 'Produkt 2') {
                  const swatchImage = swatch.querySelector('.original-variant-image').src;
                  thumbImageMain.src = swatchImage;
                } else if(swatchIndex == 'Product 3' || swatchIndex == 'Produkt 3'){
                  const swatchImage = swatch.querySelector('.original-variant-image').src;
                  thumbImageMain.src = swatchImage;
                }
                 else if(swatchIndex == 'Product 1' || swatchIndex == 'Produkt 1'){
                  const swatchImage = swatch.querySelector('.original-variant-image').src;
                  thumbImageMain.src = swatchImage;
                }
                else if(swatchIndex == 'Product 4' || swatchIndex == 'Produkt 4'){
                  const swatchImage = swatch.querySelector('.original-variant-image').src;
                  thumbImageMain.src = swatchImage;
                }
                else if(swatchIndex == 'Product 5' || swatchIndex == 'Produkt 5'){
                  const swatchImage = swatch.querySelector('.original-variant-image').src;
                  thumbImageMain.src = swatchImage;
                }


                const swatch_data_title = swatch.getAttribute('data-option-value');
                if(swatch.hasAttribute('aria-pressed')) return;

                const optionLabelParent = swatch.closest('.sb-io__group-content');
                const optionLabelInner = optionLabelParent.querySelector('.selected-swatch-label');
                optionLabelInner.innerText = swatch_data_title;

                allSwatchButtons.forEach(_swatch=>{
                  _swatch.removeAttribute('aria-pressed');
                })
                swatch.setAttribute('aria-pressed', true);

                const prop_key = swatch.getAttribute('data-identify-key');
                const allSelectTagsFromDropdownOption = SimpleBundleDropdownOptionsContainer.querySelectorAll('select');
                if(allSelectTagsFromDropdownOption.length > 0){
                  allSelectTagsFromDropdownOption.forEach(select=>{
                    if(select.getAttribute('id') == prop_key){
                      select.value = swatch_data_title;
                      // select.dispatchEvent('change', {bubbles: true});
                      select.dispatchEvent(
                        new Event('change', { bubbles: true })
                      );
                    }
                  })
                }
              });
            })
          }
        }
      })
    }
  }
}

document.addEventListener('DOMContentLoaded', ()=>{
  setTimeout(window.customBundleFunctionality, 1000);
})
// Bundle custom js ends

document.addEventListener("DOMContentLoaded", function () {

  var mainWrapper = document.querySelector(".product-main-slider .swiper-wrapper");
  var thumbWrapper = document.querySelector(".product-thumb-slider .swiper-wrapper");
  var mediaSlider = document.querySelector(".product-media-slider");

  var isGripTapesTemplate =
    document.body.classList.contains('template-product-grip-tapes-2-new') ||
    document.body.classList.contains('template-product-grip-tapes-2');

  // Snapshot slides BEFORE Swiper touches the DOM
  var origMain  = mainWrapper  ? Array.from(mainWrapper.querySelectorAll(".swiper-slide")).map(function(s){ return s.outerHTML; }) : [];
  var origThumb = thumbWrapper ? Array.from(thumbWrapper.querySelectorAll(".swiper-slide")).map(function(s){ return s.outerHTML; }) : [];

  var thumbSwiper = null;
  var mainSwiper  = null;
  var galleryReady = false;

  function showProductGallery() {
    if (!mediaSlider) return;
    mediaSlider.classList.remove('product-media-slider--loading');
  }

  function buildSwipers() {
    if (thumbSwiper) thumbSwiper.destroy(true, true);
    if (mainSwiper)  mainSwiper.destroy(true, true);

    thumbSwiper = new Swiper(".product-thumb-slider", {
      spaceBetween: 16,
      slidesPerView: 5,
      freeMode: true,
      watchSlidesProgress: true,
      scrollbar: { el: ".product-thumb-slider .swiper-scrollbar", draggable: true },
      breakpoints: {
        0:   { slidesPerView: 5, spaceBetween: 5 },
        768: { slidesPerView: 5, spaceBetween: 5 }
      }
    });

    mainSwiper = new Swiper(".product-main-slider", {
      spaceBetween: 0,
      loop: false,
      navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
      thumbs: { swiper: thumbSwiper }
    });
  }

  // --- Variant filtering (only active when data-variant-anchor attrs are present) ---

  var hasAnchors = mainWrapper && Array.from(mainWrapper.querySelectorAll(".swiper-slide"))
    .some(function(s){ return (s.dataset.variantAnchor || "").trim() !== ""; });

  function filterByVariant(variantId) {
    if (!mainWrapper && !thumbWrapper) return;

    // Restore all original slides
    if (mainWrapper)  mainWrapper.innerHTML  = origMain.join("");
    if (thumbWrapper) thumbWrapper.innerHTML = origThumb.join("");

    if (variantId && hasAnchors) {
      [mainWrapper, thumbWrapper].forEach(function(wrapper) {
        if (!wrapper) return;
        var slides = Array.from(wrapper.querySelectorAll(".swiper-slide"));
        var block  = null;
        var remove = [];

        slides.forEach(function(slide) {
          var anchor = (slide.dataset.variantAnchor || "").trim();
          if (anchor) block = anchor;
          if (block !== null && block !== String(variantId)) remove.push(slide);
        });

        // Only filter when the selected variant has at least one slide
        if (remove.length < slides.length) {
          remove.forEach(function(s){ s.remove(); });
        }
      });
    }

    buildSwipers();

    if (!galleryReady) {
      galleryReady = true;
      requestAnimationFrame(function () {
        requestAnimationFrame(showProductGallery);
      });
    } else {
      showProductGallery();
    }
  }

  function getActiveVariantId() {
    var params = new URLSearchParams(window.location.search);
    var urlVariant = params.get('variant');
    if (urlVariant) {
      var parsed = parseInt(urlVariant, 10);
      if (!isNaN(parsed)) return parsed;
    }
    var initInput = document.querySelector('product-info input.product-variant-id[name="id"]');
    return initInput ? parseInt(initInput.value, 10) : null;
  }

  window.filterProductGalleryByVariant = filterByVariant;

  var initVariant = getActiveVariantId();
  if (hasAnchors && initVariant) {
    filterByVariant(initVariant);
  } else {
    buildSwipers();
    showProductGallery();
  }

  // Grip tapes: retry once in case Option 1 sync adjusts the selected variant after load
  if (isGripTapesTemplate && hasAnchors) {
    setTimeout(function () {
      var fallbackVariant = getActiveVariantId();
      if (fallbackVariant) filterByVariant(fallbackVariant);
    }, 300);
  }

  document.addEventListener('grip-tapes:gallery-filter', function (e) {
    if (e.detail && e.detail.variantId) {
      filterByVariant(e.detail.variantId);
    }
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event.data && event.data.variant;
      if (variant && variant.id) filterByVariant(variant.id);
    });
  }

  document.addEventListener('change', function(e) {
    if (e.target.tagName === 'INPUT' && e.target.name === 'id' && e.target.closest('product-info')) {
      var vid = parseInt(e.target.value, 10);
      if (!isNaN(vid)) filterByVariant(vid);
    }
  });

});
